export { default } from './trash'
